/* tslint:disable */
/* eslint-disable */
/**
 * ElisTech API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.0
 * Contact: info@ideatech.cz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiV1DeviceCheckSubscriptionPostRequest } from '../models';
// @ts-ignore
import type { ApiV1DeviceDebugEncryptTimestampPost200Response } from '../models';
// @ts-ignore
import type { ApiV1DeviceOrderCalibrationPost201Response } from '../models';
// @ts-ignore
import type { ApiV1DeviceSaveSystemDataPostRequest } from '../models';
// @ts-ignore
import type { DeviceCalibrationResponse } from '../models';
// @ts-ignore
import type { DeviceSubscriptionStatus } from '../models';
// @ts-ignore
import type { DeviceSystemDataResponse } from '../models';
// @ts-ignore
import type { OrderCalibrationRequest } from '../models';
/**
 * DeviceApi - axios parameter creator
 */
export const DeviceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Check device subscription status
         * @param {ApiV1DeviceCheckSubscriptionPostRequest} [apiV1DeviceCheckSubscriptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DeviceCheckSubscriptionPost: async (apiV1DeviceCheckSubscriptionPostRequest?: ApiV1DeviceCheckSubscriptionPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/device/check-subscription`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiV1DeviceCheckSubscriptionPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check device subscription status
         * @param {ApiV1DeviceCheckSubscriptionPostRequest} [apiV1DeviceCheckSubscriptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DeviceCheckSubscriptionPost_1: async (apiV1DeviceCheckSubscriptionPostRequest?: ApiV1DeviceCheckSubscriptionPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/device/check-subscription`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiV1DeviceCheckSubscriptionPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Encrypts a timestamp for a given serial number (debug only).
         * @summary Debug encrypt timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DeviceDebugEncryptTimestampPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/device/debug-encrypt-timestamp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Encrypts a timestamp for a given serial number (debug only).
         * @summary Debug encrypt timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DeviceDebugEncryptTimestampPost_2: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/device/debug-encrypt-timestamp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get last calibration info
         * @param {ApiV1DeviceCheckSubscriptionPostRequest} [apiV1DeviceCheckSubscriptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DeviceLastCalibrationPost: async (apiV1DeviceCheckSubscriptionPostRequest?: ApiV1DeviceCheckSubscriptionPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/device/last-calibration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiV1DeviceCheckSubscriptionPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get last calibration info
         * @param {ApiV1DeviceCheckSubscriptionPostRequest} [apiV1DeviceCheckSubscriptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DeviceLastCalibrationPost_3: async (apiV1DeviceCheckSubscriptionPostRequest?: ApiV1DeviceCheckSubscriptionPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/device/last-calibration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiV1DeviceCheckSubscriptionPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Order calibration (calibration-expired alert lead)
         * @param {OrderCalibrationRequest} orderCalibrationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DeviceOrderCalibrationPost: async (orderCalibrationRequest: OrderCalibrationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderCalibrationRequest' is not null or undefined
            assertParamExists('apiV1DeviceOrderCalibrationPost', 'orderCalibrationRequest', orderCalibrationRequest)
            const localVarPath = `/api/v1/device/order-calibration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orderCalibrationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Order calibration (calibration-expired alert lead)
         * @param {OrderCalibrationRequest} orderCalibrationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DeviceOrderCalibrationPost_4: async (orderCalibrationRequest: OrderCalibrationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderCalibrationRequest' is not null or undefined
            assertParamExists('apiV1DeviceOrderCalibrationPost_4', 'orderCalibrationRequest', orderCalibrationRequest)
            const localVarPath = `/api/v1/device/order-calibration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orderCalibrationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Save device system data
         * @param {ApiV1DeviceSaveSystemDataPostRequest} apiV1DeviceSaveSystemDataPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DeviceSaveSystemDataPost: async (apiV1DeviceSaveSystemDataPostRequest: ApiV1DeviceSaveSystemDataPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiV1DeviceSaveSystemDataPostRequest' is not null or undefined
            assertParamExists('apiV1DeviceSaveSystemDataPost', 'apiV1DeviceSaveSystemDataPostRequest', apiV1DeviceSaveSystemDataPostRequest)
            const localVarPath = `/api/v1/device/save-system-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiV1DeviceSaveSystemDataPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Save device system data
         * @param {ApiV1DeviceSaveSystemDataPostRequest} apiV1DeviceSaveSystemDataPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DeviceSaveSystemDataPost_5: async (apiV1DeviceSaveSystemDataPostRequest: ApiV1DeviceSaveSystemDataPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiV1DeviceSaveSystemDataPostRequest' is not null or undefined
            assertParamExists('apiV1DeviceSaveSystemDataPost_5', 'apiV1DeviceSaveSystemDataPostRequest', apiV1DeviceSaveSystemDataPostRequest)
            const localVarPath = `/api/v1/device/save-system-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiV1DeviceSaveSystemDataPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DeviceApi - functional programming interface
 */
export const DeviceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DeviceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Check device subscription status
         * @param {ApiV1DeviceCheckSubscriptionPostRequest} [apiV1DeviceCheckSubscriptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DeviceCheckSubscriptionPost(apiV1DeviceCheckSubscriptionPostRequest?: ApiV1DeviceCheckSubscriptionPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeviceSubscriptionStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DeviceCheckSubscriptionPost(apiV1DeviceCheckSubscriptionPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeviceApi.apiV1DeviceCheckSubscriptionPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Check device subscription status
         * @param {ApiV1DeviceCheckSubscriptionPostRequest} [apiV1DeviceCheckSubscriptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DeviceCheckSubscriptionPost_1(apiV1DeviceCheckSubscriptionPostRequest?: ApiV1DeviceCheckSubscriptionPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeviceSubscriptionStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DeviceCheckSubscriptionPost_1(apiV1DeviceCheckSubscriptionPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeviceApi.apiV1DeviceCheckSubscriptionPost_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Encrypts a timestamp for a given serial number (debug only).
         * @summary Debug encrypt timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DeviceDebugEncryptTimestampPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1DeviceDebugEncryptTimestampPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DeviceDebugEncryptTimestampPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeviceApi.apiV1DeviceDebugEncryptTimestampPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Encrypts a timestamp for a given serial number (debug only).
         * @summary Debug encrypt timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DeviceDebugEncryptTimestampPost_2(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1DeviceDebugEncryptTimestampPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DeviceDebugEncryptTimestampPost_2(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeviceApi.apiV1DeviceDebugEncryptTimestampPost_2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get last calibration info
         * @param {ApiV1DeviceCheckSubscriptionPostRequest} [apiV1DeviceCheckSubscriptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DeviceLastCalibrationPost(apiV1DeviceCheckSubscriptionPostRequest?: ApiV1DeviceCheckSubscriptionPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeviceCalibrationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DeviceLastCalibrationPost(apiV1DeviceCheckSubscriptionPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeviceApi.apiV1DeviceLastCalibrationPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get last calibration info
         * @param {ApiV1DeviceCheckSubscriptionPostRequest} [apiV1DeviceCheckSubscriptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DeviceLastCalibrationPost_3(apiV1DeviceCheckSubscriptionPostRequest?: ApiV1DeviceCheckSubscriptionPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeviceCalibrationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DeviceLastCalibrationPost_3(apiV1DeviceCheckSubscriptionPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeviceApi.apiV1DeviceLastCalibrationPost_3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Order calibration (calibration-expired alert lead)
         * @param {OrderCalibrationRequest} orderCalibrationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DeviceOrderCalibrationPost(orderCalibrationRequest: OrderCalibrationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1DeviceOrderCalibrationPost201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DeviceOrderCalibrationPost(orderCalibrationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeviceApi.apiV1DeviceOrderCalibrationPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Order calibration (calibration-expired alert lead)
         * @param {OrderCalibrationRequest} orderCalibrationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DeviceOrderCalibrationPost_4(orderCalibrationRequest: OrderCalibrationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1DeviceOrderCalibrationPost201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DeviceOrderCalibrationPost_4(orderCalibrationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeviceApi.apiV1DeviceOrderCalibrationPost_4']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Save device system data
         * @param {ApiV1DeviceSaveSystemDataPostRequest} apiV1DeviceSaveSystemDataPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DeviceSaveSystemDataPost(apiV1DeviceSaveSystemDataPostRequest: ApiV1DeviceSaveSystemDataPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeviceSystemDataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DeviceSaveSystemDataPost(apiV1DeviceSaveSystemDataPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeviceApi.apiV1DeviceSaveSystemDataPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Save device system data
         * @param {ApiV1DeviceSaveSystemDataPostRequest} apiV1DeviceSaveSystemDataPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1DeviceSaveSystemDataPost_5(apiV1DeviceSaveSystemDataPostRequest: ApiV1DeviceSaveSystemDataPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeviceSystemDataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DeviceSaveSystemDataPost_5(apiV1DeviceSaveSystemDataPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeviceApi.apiV1DeviceSaveSystemDataPost_5']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DeviceApi - factory interface
 */
export const DeviceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DeviceApiFp(configuration)
    return {
        /**
         * 
         * @summary Check device subscription status
         * @param {ApiV1DeviceCheckSubscriptionPostRequest} [apiV1DeviceCheckSubscriptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DeviceCheckSubscriptionPost(apiV1DeviceCheckSubscriptionPostRequest?: ApiV1DeviceCheckSubscriptionPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeviceSubscriptionStatus> {
            return localVarFp.apiV1DeviceCheckSubscriptionPost(apiV1DeviceCheckSubscriptionPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Check device subscription status
         * @param {ApiV1DeviceCheckSubscriptionPostRequest} [apiV1DeviceCheckSubscriptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DeviceCheckSubscriptionPost_1(apiV1DeviceCheckSubscriptionPostRequest?: ApiV1DeviceCheckSubscriptionPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeviceSubscriptionStatus> {
            return localVarFp.apiV1DeviceCheckSubscriptionPost_1(apiV1DeviceCheckSubscriptionPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Encrypts a timestamp for a given serial number (debug only).
         * @summary Debug encrypt timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DeviceDebugEncryptTimestampPost(options?: RawAxiosRequestConfig): AxiosPromise<ApiV1DeviceDebugEncryptTimestampPost200Response> {
            return localVarFp.apiV1DeviceDebugEncryptTimestampPost(options).then((request) => request(axios, basePath));
        },
        /**
         * Encrypts a timestamp for a given serial number (debug only).
         * @summary Debug encrypt timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DeviceDebugEncryptTimestampPost_2(options?: RawAxiosRequestConfig): AxiosPromise<ApiV1DeviceDebugEncryptTimestampPost200Response> {
            return localVarFp.apiV1DeviceDebugEncryptTimestampPost_2(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get last calibration info
         * @param {ApiV1DeviceCheckSubscriptionPostRequest} [apiV1DeviceCheckSubscriptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DeviceLastCalibrationPost(apiV1DeviceCheckSubscriptionPostRequest?: ApiV1DeviceCheckSubscriptionPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeviceCalibrationResponse> {
            return localVarFp.apiV1DeviceLastCalibrationPost(apiV1DeviceCheckSubscriptionPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get last calibration info
         * @param {ApiV1DeviceCheckSubscriptionPostRequest} [apiV1DeviceCheckSubscriptionPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DeviceLastCalibrationPost_3(apiV1DeviceCheckSubscriptionPostRequest?: ApiV1DeviceCheckSubscriptionPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeviceCalibrationResponse> {
            return localVarFp.apiV1DeviceLastCalibrationPost_3(apiV1DeviceCheckSubscriptionPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Order calibration (calibration-expired alert lead)
         * @param {OrderCalibrationRequest} orderCalibrationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DeviceOrderCalibrationPost(orderCalibrationRequest: OrderCalibrationRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1DeviceOrderCalibrationPost201Response> {
            return localVarFp.apiV1DeviceOrderCalibrationPost(orderCalibrationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Order calibration (calibration-expired alert lead)
         * @param {OrderCalibrationRequest} orderCalibrationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DeviceOrderCalibrationPost_4(orderCalibrationRequest: OrderCalibrationRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1DeviceOrderCalibrationPost201Response> {
            return localVarFp.apiV1DeviceOrderCalibrationPost_4(orderCalibrationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Save device system data
         * @param {ApiV1DeviceSaveSystemDataPostRequest} apiV1DeviceSaveSystemDataPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DeviceSaveSystemDataPost(apiV1DeviceSaveSystemDataPostRequest: ApiV1DeviceSaveSystemDataPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeviceSystemDataResponse> {
            return localVarFp.apiV1DeviceSaveSystemDataPost(apiV1DeviceSaveSystemDataPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Save device system data
         * @param {ApiV1DeviceSaveSystemDataPostRequest} apiV1DeviceSaveSystemDataPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DeviceSaveSystemDataPost_5(apiV1DeviceSaveSystemDataPostRequest: ApiV1DeviceSaveSystemDataPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeviceSystemDataResponse> {
            return localVarFp.apiV1DeviceSaveSystemDataPost_5(apiV1DeviceSaveSystemDataPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DeviceApi - object-oriented interface
 */
export class DeviceApi extends BaseAPI {
    /**
     * 
     * @summary Check device subscription status
     * @param {ApiV1DeviceCheckSubscriptionPostRequest} [apiV1DeviceCheckSubscriptionPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1DeviceCheckSubscriptionPost(apiV1DeviceCheckSubscriptionPostRequest?: ApiV1DeviceCheckSubscriptionPostRequest, options?: RawAxiosRequestConfig) {
        return DeviceApiFp(this.configuration).apiV1DeviceCheckSubscriptionPost(apiV1DeviceCheckSubscriptionPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Check device subscription status
     * @param {ApiV1DeviceCheckSubscriptionPostRequest} [apiV1DeviceCheckSubscriptionPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1DeviceCheckSubscriptionPost_1(apiV1DeviceCheckSubscriptionPostRequest?: ApiV1DeviceCheckSubscriptionPostRequest, options?: RawAxiosRequestConfig) {
        return DeviceApiFp(this.configuration).apiV1DeviceCheckSubscriptionPost_1(apiV1DeviceCheckSubscriptionPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Encrypts a timestamp for a given serial number (debug only).
     * @summary Debug encrypt timestamp
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1DeviceDebugEncryptTimestampPost(options?: RawAxiosRequestConfig) {
        return DeviceApiFp(this.configuration).apiV1DeviceDebugEncryptTimestampPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Encrypts a timestamp for a given serial number (debug only).
     * @summary Debug encrypt timestamp
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1DeviceDebugEncryptTimestampPost_2(options?: RawAxiosRequestConfig) {
        return DeviceApiFp(this.configuration).apiV1DeviceDebugEncryptTimestampPost_2(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get last calibration info
     * @param {ApiV1DeviceCheckSubscriptionPostRequest} [apiV1DeviceCheckSubscriptionPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1DeviceLastCalibrationPost(apiV1DeviceCheckSubscriptionPostRequest?: ApiV1DeviceCheckSubscriptionPostRequest, options?: RawAxiosRequestConfig) {
        return DeviceApiFp(this.configuration).apiV1DeviceLastCalibrationPost(apiV1DeviceCheckSubscriptionPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get last calibration info
     * @param {ApiV1DeviceCheckSubscriptionPostRequest} [apiV1DeviceCheckSubscriptionPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1DeviceLastCalibrationPost_3(apiV1DeviceCheckSubscriptionPostRequest?: ApiV1DeviceCheckSubscriptionPostRequest, options?: RawAxiosRequestConfig) {
        return DeviceApiFp(this.configuration).apiV1DeviceLastCalibrationPost_3(apiV1DeviceCheckSubscriptionPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Order calibration (calibration-expired alert lead)
     * @param {OrderCalibrationRequest} orderCalibrationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1DeviceOrderCalibrationPost(orderCalibrationRequest: OrderCalibrationRequest, options?: RawAxiosRequestConfig) {
        return DeviceApiFp(this.configuration).apiV1DeviceOrderCalibrationPost(orderCalibrationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Order calibration (calibration-expired alert lead)
     * @param {OrderCalibrationRequest} orderCalibrationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1DeviceOrderCalibrationPost_4(orderCalibrationRequest: OrderCalibrationRequest, options?: RawAxiosRequestConfig) {
        return DeviceApiFp(this.configuration).apiV1DeviceOrderCalibrationPost_4(orderCalibrationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Save device system data
     * @param {ApiV1DeviceSaveSystemDataPostRequest} apiV1DeviceSaveSystemDataPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1DeviceSaveSystemDataPost(apiV1DeviceSaveSystemDataPostRequest: ApiV1DeviceSaveSystemDataPostRequest, options?: RawAxiosRequestConfig) {
        return DeviceApiFp(this.configuration).apiV1DeviceSaveSystemDataPost(apiV1DeviceSaveSystemDataPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Save device system data
     * @param {ApiV1DeviceSaveSystemDataPostRequest} apiV1DeviceSaveSystemDataPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1DeviceSaveSystemDataPost_5(apiV1DeviceSaveSystemDataPostRequest: ApiV1DeviceSaveSystemDataPostRequest, options?: RawAxiosRequestConfig) {
        return DeviceApiFp(this.configuration).apiV1DeviceSaveSystemDataPost_5(apiV1DeviceSaveSystemDataPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

